import axios from 'axios'
import { errorMessage } from '~/services/messager'
import { Auth } from 'aws-amplify'

const serviceAPI = (baseURL) => {
	const api = axios.create({ baseURL })

	api.interceptors.request.use(async (config) => {
		// in case there is a logged in user, get the token from amplify auth
		// and add it as an atuh beare token to the api
		try {
			// Login legado!
			let session = null
			let jwtToken = null
			try {
				session = await Auth.currentSession()
				// const accessToken = session.getIdToken()
				const accessToken = session.getAccessToken()
				jwtToken = accessToken.getJwtToken()
			} catch (erroAuth) {
				// console.log("2 ::: ", erroAuth)
				const userContracts = JSON.parse(localStorage.getItem('user-contracts'))
				jwtToken = userContracts?.accessToken
				// console.log("TOKEN .... 2 ::: ", jwtToken)
			}
			if (jwtToken) config.headers['Authorization'] = `Bearer ${jwtToken}`
		} catch (error) {
			console.log(error)
		}
		return config
	})

	api.interceptors.response.use(
		(response) => {
			return response
		},
		(error) => {
			if (!window.navigator.onLine) {
				errorMessage({
					content:
						'Não conseguimos contato com nossos servidores. O dispositivo está conectado?',
				})
			} else if (
				error.response.status === 401 ||
				error.response.status === 403
			) {
				//store.dispatch(logout())

				// return Promise.reject(error)
				return null
			} else if (error.response.status === 400) {
				return Promise.reject(error)
			} else {
				errorMessage({
					content:
						'Ooops, ocorreu um erro. Já avisamos nossos engenheiros, por favor tente mais tarde.',
				})
			}
		}
	)

	return api
}

export default serviceAPI
